import { BaseEntityService } from "../BaseEntityService"
import { SubscriptionItemModel } from "../../data/entities/billing";
import { SubscriptionItemODataRepo, SubscriptionItemRepo } from "../../data/repo";

export class SubscriptionItemService extends BaseEntityService<SubscriptionItemModel, SubscriptionItemRepo, SubscriptionItemODataRepo> {
  constructor(){
    super(new SubscriptionItemRepo(), new SubscriptionItemODataRepo());
  }
}

export default SubscriptionItemService;
